import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, throwError } from "rxjs";
import { IConfigurationService } from "./IConfiguration.service";
import { IConfiguration } from "./IConfiguration";
import { CurrentEnvironment } from "./constants";
import { IEnvironmentSettings } from "./IEnvironmentSettings";
import { environment } from './environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private configurations = new ReplaySubject<IConfiguration>(1);
  private environment = new ReplaySubject<IEnvironmentSettings>(1);

  readonly configs$: Observable<IConfiguration> = this.configurations.asObservable();
  readonly environment$: Observable<IEnvironmentSettings> = this.environment.asObservable();
  async fetchEnvironment() {
   
    try {
      let configs: IEnvironmentSettings = await fetch(CurrentEnvironment).then(res => {
        if (!res.ok) {
          return Promise.reject(new Error("Response with ok is false"));
        }
        return res.json();
      });

      this.environment.next(configs);
    } catch (error) {
      throw error;
    }
  }

  async fetchConfiguration(environment: any) {
    try {
      // Server-side config from Key Vault (secrets, API base URIs, MSAL settings, etc.)
      const response = await fetch('/api/config');
      if (!response.ok) {
        throw new Error(`Failed to load configuration from server: ${response.status} ${response.statusText}`);
      }
      const serverConfig = await response.json();

      // Local feature flags (not secrets — kept in source control for easy toggling)
      const flagsResponse = await fetch('assets/json/feature-flags.json');
      if (flagsResponse.ok) {
        serverConfig.featureFlags = await flagsResponse.json();
      }

      return serverConfig;
    } catch (error) {
      throw error;
    }
  }
  async getConfiguration(configFile: any) {
    try {
      let configs: IConfiguration = await fetch(configFile).then(res => {
       
        if (!res.ok) {
          return Promise.reject(new Error("Response with ok is false"));
        }
        return res.json();
      });

      this.configurations.next(configs);
    } catch (error) {
      throw error;
    }
  }

  async mapConfigurationSettings(configurations:any)
  {
    environment.ProductionEnv = configurations?.ProductionEnv
    environment.production = configurations?.production
    environment.title = configurations?.title
    environment.env = configurations?.env
    environment.HostUri = configurations?.HostUri
    environment.ApiHostUri = configurations?.ApiHostUri
    environment.tenant = configurations?.tenant
    environment.clientId = configurations?.clientId
    environment.resourceId = configurations?.resourceId
    environment.ApiBaseUri = configurations?.ApiBaseUri
    environment.ApiBasePOAUri = configurations?.ApiBasePOAUri
    environment.ApiBaseAuditTrailUri = configurations?.ApiBaseAuditTrailUri
    environment.ApiBaseBrokerageFeeUri = configurations?.ApiBaseBrokerageFeeUri
    environment.ApiBaseCountryFieldUri = configurations?.ApiBaseCountryFieldUri
    environment.ApiBaseDPSUri = configurations?.ApiBaseDPSUri
    environment.ApiBaseIECUri = configurations?.ApiBaseIECUri
    environment.ApiBaseIECBulkUri = configurations?.ApiBaseIECBulkUri
    environment.ApiBaseWCUri = configurations?.ApiBaseWCUri
    environment.ApiBaseCountryFieldUri = configurations?.ApiBaseCountryFieldUri
    environment.ApiBaseWCRefUri = configurations?.ApiBaseWCRefUri
    environment.logOut = configurations?.logOut
    environment.featureFlags = configurations?.featureFlags
  }
}
